import { lazy } from 'react';

import { withSuspense } from '@/shared/lib/hocs/with-suspense.hoc';

export const LoginPage = withSuspense(lazy(() => import('./login-page.component')));
